import { USER_ROLE_SET } from "./UserRoleSet";

export const QUICK_RANGE_AUTH = () =>{
  const today = new Date();
  today.setFullYear(today.getFullYear()-3);
  return today;
}

export const QUICK_RANGE = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear(), today.getMonth()-3);
  return today;
}

export const REPORT_RANGE = (role) => {
  const today = new Date();
  const date_calc = new Date();
  USER_ROLE_SET.filter((item)=>item.role==role).forEach(
    (item)=>{
      switch (item.unit){
        case "Y":
          date_calc.setFullYear(today.getFullYear()-parseInt(item.maxDateRange));
          break;
        case "M":
          date_calc.setFullYear(today.getFullYear(), today.getMonth()-parseInt(item.maxDateRange));
          break;
        case "W":
          date_calc.setDate(today.getDate()-7*parseInt(item.maxDateRange));
          break;
        default:
          break;
      }
    }
  )
  return date_calc;
}

export const SNAPSHOT_RANGE = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear(), today.getMonth()-1);
  return today;
}